import { render, staticRenderFns } from "./Graduates.vue?vue&type=template&id=19b60b9e&scoped=true"
import script from "./Graduates.vue?vue&type=script&lang=ts"
export * from "./Graduates.vue?vue&type=script&lang=ts"
import style0 from "./Graduates.vue?vue&type=style&index=0&id=19b60b9e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19b60b9e",
  null
  
)

export default component.exports